import React, { useEffect, useRef, useState } from "react";
import { api, API } from "@/lib/api";

export default function BannerCarousel({ placement = "home", className = "" }) {
  const [banners, setBanners] = useState([]);
  const [idx, setIdx] = useState(0);
  const timer = useRef(null);
  const isHome = placement === "home";

  useEffect(() => {
    api.get("/banners", { params: { placement } }).then((res) => setBanners(res.data)).catch(() => {});
  }, [placement]);

  useEffect(() => {
    if (banners.length <= 1) return;
    timer.current = setInterval(() => setIdx((i) => (i + 1) % banners.length), 5000);
    return () => clearInterval(timer.current);
  }, [banners.length]);

  if (banners.length === 0) return null;

  const go = (i) => {
    setIdx(i);
    if (timer.current) clearInterval(timer.current);
  };

  const imgCls = isHome ? "h-56 w-full shrink-0 object-cover sm:h-72 lg:h-96" : "h-36 w-full shrink-0 object-cover sm:h-48";

  return (
    <section className={isHome ? "reveal mx-auto max-w-6xl px-5 pt-8" : className} data-testid={isHome ? "banner-carousel" : `banner-carousel-${placement}`}>
      <div className="relative overflow-hidden rounded-3xl border border-slate-200/20 bg-slate-100 shadow-sm">
        <div className="flex transition-transform duration-500 ease-out" style={{ transform: `translateX(-${idx * 100}%)` }}>
          {banners.map((b) => {
            const img = <img src={`${API}/banners/${b.id}/image`} alt="Publicidade Dubal Esportes" loading="lazy" className={imgCls} />;
            return b.link ? (
              <a key={b.id} href={b.link} target="_blank" rel="noopener noreferrer" className="w-full shrink-0" data-testid={`banner-link-${b.id}`}>{img}</a>
            ) : (
              <div key={b.id} className="w-full shrink-0">{img}</div>
            );
          })}
        </div>

        {banners.length > 1 && (
          <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-1.5">
            {banners.map((b, i) => (
              <button key={b.id} onClick={() => go(i)} data-testid={`banner-dot-${placement}-${i}`} aria-label={`Banner ${i + 1}`} className={`h-2 rounded-full transition-all ${i === idx ? "w-6 bg-white" : "w-2 bg-white/60 hover:bg-white/80"}`} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
